import React from "react";

export interface ICellPopover<T extends object> {
    anchorEl?: Element
    isOpened: boolean
    open: (anchorEl: Element) => void
    handleMouseOpen: (record?: T) => (e: React.MouseEvent<Element, MouseEvent>) => void
    close: VoidFunction
    record?: T
    setCurrentRecord: (record?: T) => void
}

export function useCellPopover<T extends object>() {
    const [anchorEl, setAnchorEl] = React.useState<Element | undefined>(undefined);
    const [record, setRecord] = React.useState<T>();

    const open = React.useCallback((anchorEl: Element) => {
        setAnchorEl(anchorEl);
    }, []);

    const close = React.useCallback(() => {
        setAnchorEl(undefined);
    }, []);

    const setCurrentRecord = React.useCallback((record?: T) => {
        setRecord(record);
    }, []);

    const handleMouseOpen = React.useCallback((record?: T) => (e: React.MouseEvent<Element, MouseEvent>) => {
        setCurrentRecord(record);
        open(e.currentTarget);
    }, [open, setCurrentRecord]);

    return React.useMemo(() => ({
        anchorEl, isOpened: anchorEl !== undefined, open, close, handleMouseOpen, record, setCurrentRecord
    }), [anchorEl, open, close, handleMouseOpen, record, setCurrentRecord]);
}
